import type { AttributionChannelType } from './channels';
import { SEARCH_ENGINE_HOSTS } from './search-engine-hosts';
import { SOCIAL_SOURCES } from './social-sources';

export interface IClassifyChannelInput {
  source?: string | null;
  medium?: string | null;
  referrerUserId?: string | null;
  referrerHost?: string | null;
  gclid?: string | null;
}

function matchesAny(value: string, needles: readonly string[]): boolean {
  return needles.some((needle) => value.includes(needle));
}

function isSocial(source: string, medium: string, referrerHost: string): boolean {
  return (
    medium === 'social' ||
    matchesAny(source, SOCIAL_SOURCES) ||
    matchesAny(referrerHost, SOCIAL_SOURCES)
  );
}

function isPaid(medium: string, gclid: string | null | undefined): boolean {
  return Boolean(gclid) || medium === 'cpc' || medium === 'ppc' || medium === 'paid';
}

function isOrganic(source: string, medium: string, referrerHost: string): boolean {
  return (
    medium === 'organic' ||
    matchesAny(source, SEARCH_ENGINE_HOSTS) ||
    matchesAny(referrerHost, SEARCH_ENGINE_HOSTS)
  );
}

export function classifyChannel(input: IClassifyChannelInput): AttributionChannelType {
  const source = (input.source ?? '').toLowerCase();
  const medium = (input.medium ?? '').toLowerCase();
  const referrerHost = (input.referrerHost ?? '').toLowerCase();

  if (input.referrerUserId) {
    return 'referral';
  }
  if (isSocial(source, medium, referrerHost)) {
    return 'social';
  }
  if (isPaid(medium, input.gclid)) {
    return 'seo_paid';
  }
  if (isOrganic(source, medium, referrerHost)) {
    return 'seo_organic';
  }
  if (!(source || medium || referrerHost)) {
    return 'direct';
  }
  return 'other';
}
